import { render, staticRenderFns } from "./DivisionReceiverGroupPage.vue?vue&type=template&id=20a5874c"
import script from "./DivisionReceiverGroupPage.vue?vue&type=script&lang=js"
export * from "./DivisionReceiverGroupPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20a5874c')) {
      api.createRecord('20a5874c', component.options)
    } else {
      api.reload('20a5874c', component.options)
    }
    module.hot.accept("./DivisionReceiverGroupPage.vue?vue&type=template&id=20a5874c", function () {
      api.rerender('20a5874c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/division/group/DivisionReceiverGroupPage.vue"
export default component.exports